import React from 'react';
import ToolCard from './ToolCard';

const Tools: React.FC = () => {
    return (
        <div className="tools-container">
            <h2>其他小工具</h2>
            <div className="tools-grid">
                {/* 添加带路径的工具卡 */}
                <ToolCard 
                    title="工具 1" 
                    description="工具 1 描述" 
                    path="/tools" 
                />
                <ToolCard 
                    title="工具 2" 
                    description="工具 2 描述" 
                    path="/tools" 
                />
                <ToolCard 
                    title="工具 3" 
                    description="工具 3 描述" 
                    path="/tools" 
                />
            </div>
        </div>
    );
};

export default Tools;